import { GetQueryParams, GetQueryResponse } from '../../../types/api.type';
import { FranchiseeLead } from '../../../types/website.types';
import { sfcApi } from '../../api';

export const franchiseeLeadApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFranchiseeLeads: builder.query<GetQueryResponse, GetQueryParams | void>({
      query: (params) => ({
        url: `franchisee-leads${params?.scope ? `?scope=${params.scope}` : ''}`,
        method: 'POST',
        body: params?.data
      }),
      providesTags: ['FranchiseeLead']
    }),
    getFranchiseeLead: builder.query<{ franchiseeLead: FranchiseeLead }, number>({
      query: (id) => `franchisee-leads/${id}`,
      providesTags: (result, error, id) => [{ type: 'FranchiseeLead', id }]
    }),
    createFranchiseeLead: builder.mutation<{ franchiseeLead: FranchiseeLead }, FranchiseeLead>({
      query: (data) => ({
        url: `franchisee-leads/create`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['FranchiseeLead']
    }),
    updateFranchiseeLead: builder.mutation<{ franchiseeLead: FranchiseeLead }, FranchiseeLead>({
      query: (data) => {
        const { id } = data;
        delete data.id;
        return {
          url: `news-items/update/${id}`,
          method: 'PUT',
          body: data
        };
      },
      invalidatesTags: (result, error) => [
        { type: 'FranchiseeLead', id: result?.franchiseeLead?.id },
        'FranchiseeLead'
      ]
    }),
    deleteFranchiseeLead: builder.mutation<{ franchiseeLead: FranchiseeLead }, number>({
      query: (id) => ({
        url: `franchisee-leads/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['FranchiseeLead'] //(result, error, params) => [...params.ids.map(id => ({ type: 'FranchiseeLead', id })), 'FranchiseeLead']
    }),
    deleteFranchiseeLeads: builder.mutation<{ franchiseeLead: FranchiseeLead }, { ids: number[] }>({
      query: (params) => ({
        url: `franchisee-leads/bulk-delete`,
        method: 'DELETE',
        body: params
      }),
      invalidatesTags: ['FranchiseeLead'] //(result, error, params) => [...params.ids.map(id => ({ type: 'FranchiseeLead', id })), 'FranchiseeLead']
    })
  })
});

export const {
  useGetAllFranchiseeLeadsQuery,
  useGetFranchiseeLeadQuery,
  useCreateFranchiseeLeadMutation,
  useUpdateFranchiseeLeadMutation,
  useDeleteFranchiseeLeadMutation,
  useDeleteFranchiseeLeadsMutation
} = franchiseeLeadApi;
